// Constants and default values for treatment reports

export const PAGINATION_DEFAULTS = {
  page: 1,
  limit: 50,
  total: 0,
  pages: 0
};

export const FILTER_DEFAULTS = {
  search: '',
  status: '',
  technician: ''
};

export const STATUS_OPTIONS = [
  { value: '', label: 'All Statuses' },
  { value: 'draft', label: 'Draft' },
  { value: 'completed', label: 'Completed' },
  { value: 'sent', label: 'Sent' }
];

export const STATUS_COLORS = {
  draft: 'bg-yellow-100 text-yellow-800',
  completed: 'bg-green-100 text-green-800',
  sent: 'bg-blue-100 text-blue-800',
  default: 'bg-gray-100 text-gray-800'
};

export const SEARCH_DEBOUNCE_MS = 300;
export const NOTIFICATION_AUTO_DISMISS_MS = 4000;